// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsAttributionAbsoluteAppModule } from './app.module';
bootstrapAppModule(MutualFundsAttributionAbsoluteAppModule);
